import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-matching',
  templateUrl: './help-matching.component.html',
  styleUrls: ['./help-matching.component.scss']
})
export class HelpMatchingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
